import React from "react";
import * as PropTypes from "prop-types";
import { Box } from "@chakra-ui/core";
import MaclicImage from "../images/maclicImage";
import { buildURL as buildPublicURL } from "react-imgix";
import { buildURL } from "../../components/images/maclicImage";
import ImageGallery from "react-image-gallery";

import './maclic-gallery.css';

const IMAGE_OPTIONS = {
  ar: "16:10",
  auto: "format,compress",
  // sizes: "(min-width: 480px) 20vw, 10vw",
  fit: "crop",
  crop: "faces",
  width: 1600,
  height: 1000,
};

const IMAGE_OPTIONS_RAW = {
  auto: "format,compress",
  fit: "crop",
  crop: "faces",
  width: 1600,
};

const buildCustomURL = (url, raw) => {
  const uri = buildURL(url);
  const options = raw ? IMAGE_OPTIONS_RAW : IMAGE_OPTIONS;
  return {
    original: buildPublicURL(uri, { ...options, ar: "16:10", width: 960, height: 450 }),
    fullscreen: buildPublicURL(uri, options),
  };
};

const PlaceCarousel = ({ photos, raw, ...rest }) => {
  const [images, setImages] = React.useState(null);
  React.useEffect(() => {
    const theImages = photos.map(photo => buildCustomURL(photo, raw));
    setImages(theImages);
  }, [photos]);
  return !!images && (
    <Box boxShadow="lg" {...rest}>
      <ImageGallery
        items={images}
        lazyLoad={false}
        showThumbnails={false}
        showPlayButton={false}
        showBullets
        showNav={false}
        showFullscreenButton
      />
    </Box>
  );
};
const PlaceCarouselWrapper = ({ photos, raw, ...rest }) => {
  if (photos) {
    return (
      <PlaceCarousel boxShadow="xl" photos={photos} raw={raw} {...rest} />
    );
  }
  return (
    <MaclicImage boxShadow="xl" size="fullWidth" {...rest} />
  );
};

PlaceCarouselWrapper.defaultProps = {
  photos: null,
  raw: false,
};

PlaceCarouselWrapper.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.string),
  raw: PropTypes.bool,
};

export default PlaceCarouselWrapper;
